module.exports = __webpack_public_path__ + "img/icon_tips0.d3e43356.svg";